import React, { useState } from 'react';
import { useParams } from 'react-router';

import { useCommentSection, useQuestionnaireSection } from '../hooks';
import { ActionBox, Box, Label, Space } from '../../constructorCommon/styled';
import { Button, Input, Popconfirm } from 'antd';
import { useTranslation } from 'react-i18next';

export const CommentSection = ({ sectionProp, onCreated }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [section, setSection] = useState(sectionProp || {});

  const { handleCreate, handleUpdate, handleDelete, isCreating, isUpdating, isDeleting } =
    useCommentSection(id);

  const onChange = (e) => {
    const { name, value } = e.target;
    setSection({ ...section, [name]: value });
  };

  const handleAction = () => {
    if (section.id) {
      handleUpdate(section.id, section);
    } else {
      handleCreate(section).then((res) => {
        setSection({});
        onCreated && onCreated();
      });
    }
  };

  const onDelete = () => {
    handleDelete(section);
  };

  const isDisabled =
    !section.comment ||
    (section.comment_RU &&
      section.comment_DE &&
      section.comment_LV &&
      section.comment_RU === sectionProp?.comment_RU &&
      section.comment_DE === sectionProp?.comment_DE &&
      section.comment_LV === sectionProp?.comment_LV);

  return (
    <Box $isNew={!section.id}>
      <Label>Comment</Label>
      <Input name='comment' value={section.comment} onChange={onChange} placeholder='comment' />
      <Space />

      <Label>Сomment RU</Label>
      <Input
        name='comment_RU'
        value={section.comment_RU}
        onChange={onChange}
        placeholder='comment_RU'
      />
      <Space />

      <Label>Сomment DE</Label>
      <Input
        name='comment_DE'
        value={section.comment_DE}
        onChange={onChange}
        placeholder='comment_DE'
      />
      <Space />

      <Label>Сomment LV</Label>
      <Input
        name='comment_LV'
        value={section.comment_LV}
        onChange={onChange}
        placeholder='comment_LV'
      />
      <Space />

      <ActionBox>
        <Button
          onClick={handleAction}
          disabled={isDisabled}
          type='primary'
          loading={isCreating || isUpdating}
        >
          {section.id ? t('Update Comment') : t('Create Comment')}
        </Button>

        {section.id && (
          <Popconfirm
            placement='topRight'
            title={t('Are you sure to delete this comment?')}
            onConfirm={onDelete}
            okText={t('Yes')}
            cancelText={t('No')}
          >
            <Button danger loading={isDeleting}>
              {t('Delete comment')}
            </Button>
          </Popconfirm>
        )}
      </ActionBox>
    </Box>
  );
};
